import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email: email.trim() }); setMsg(data.message); }
    catch (e) { setMsg(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="dark flex min-h-screen items-center justify-center bg-[hsl(222_47%_6%)] p-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[hsl(217_33%_14%)] p-8 shadow-2xl">
        <h1 className="font-head text-2xl font-bold text-white">Reset your password</h1>
        <p className="mt-1 text-sm text-slate-400">We'll email you a reset link if the account exists.</p>
        {msg ? (
          <p className="mt-6 rounded-lg bg-emerald-500/10 px-3 py-3 text-sm text-emerald-400" data-testid="forgot-message">{msg}</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label className="text-slate-300">Email</Label>
              <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@connecttym.com" /></div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit" className="h-11 w-full font-semibold">{busy ? "Sending…" : "Send reset link"}</Button>
          </form>
        )}
        <div className="mt-6 text-center"><Link to="/login" className="text-sm text-blue-400 hover:underline">Back to sign in</Link></div>
      </div>
    </div>
  );
}
